import { sendGlamLABVisited, sendWentToCategory, sendSkuTried } from "./HangHandler";

const getHangUserId = () => {
  const queryParams = new URLSearchParams(window.location.search);
  const parentQueryParams = new URLSearchParams(window.parent.location.search);

  return queryParams.get("hUId") || parentQueryParams.get("hUId");
};

export const didStartLTO = () => {
  const hangUserId = getHangUserId();
  if (hangUserId && hangUserId.length > 0) {
    sendGlamLABVisited(hangUserId);
  }
};

export const didChangeCategory = (category) => {
  const hangUserId = getHangUserId();
  if (hangUserId && hangUserId.length > 0) {
    if (category === "eyeshadow") {
      sendWentToCategory(hangUserId, category);
    }
  }
};

export const didDeeplinkSku = (sku) => { 
  const hangUserId = getHangUserId();
  if (hangUserId && hangUserId.length > 0) {
    sendSkuTried(hangUserId, sku);
  }
}
